import { WikModel } from './WikModel.class';

export class Point extends WikModel {
  px = 0;
  py = 0;
  pz = 0;
}
